import React from "react";
import Layout from '../../layouts/Layout'
import { Calendar,Badge,Select,Row, Col,Button } from 'antd';
import _ from 'lodash';
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import moment from 'moment';

moment.updateLocale('en', {
  weekdaysMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  // months:['January(TH)', 'February(TH)', 'March(TH)', 'April(TH)', 'May(TH)', 'June(TH)', 'July(TH)', 'August(TH)', 'September(TH)', 'October(TH)', 'November(TH)', 'December(TH)']
});

function getMonthData(value) {
  if (value.month() === 8) {
    return 1394;
  }
}

function monthCellRender(value) {
  const num = getMonthData(value);
  return num ? (
    <div className="notes-month">
      <section>{num}</section>
      <span>Backlog number</span>
    </div>
  ) : null;
}

class MySchedule extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      calendar_data:[
        {'date':moment().add('d',-1),'type':'error'},
        {'date':moment().add('d',-1),'type':'error'},
        {'date':moment().add('d',-1),'type':'error'},
        {'date':moment(),'type':'error'},
        {'date':moment().add('d',1),'type':'warning'},
        {'date':moment().add('d',5),'type':'warning'},
        {'date':moment().add('d',10),'type':'warning'},
        {'date':moment().add('d',7),'type':'success'},
        {'date':moment().add('d',3),'type':'success'},
      ],
      date: moment(),
    };
    this.onPanelChange = this.onPanelChange.bind(this)
    this.dateCellRender = this.dateCellRender.bind(this)
    console.log("moment",moment().format("DD-MMMM-YYYY"));
  }

  componentDidMount() {

  }

  onPanelChange(value, mode) {
    this.setState({ date: value }, () => {
      // this.getData()
    });
  }

  getListData(value) {
    let listData;
    let temp = _.find(this.state.calendar_data, r => r.date.format("DD-MM-YYYY") === value.format("DD-MM-YYYY"));
    let date = this.state.date;
    let month = date.month() + 1;
    if (temp && value.month() + 1 === month) {
      listData = [
        { type: temp.type, content: '' },
      ]
    }
    return listData || [];
  }

  dateCellRender(value) {
    const listData = this.getListData(value);
    return (<>
        {listData.map(item => (
            <Badge status={item.type} />
        ))}
    </>);
  }


    render() {
      let { error,data } = this.state
        return <Layout>
              <div className="container-profile">
                <div className="header">
                  <div className="main-header-text">ข้อมูลสมาชิก</div>
                </div>
              </div>

              <div className="main-calendar">
              <Calendar
                value={this.state.date}
                onSelect={(e) => {
                  console.log("onSelect", e);
                }}
                onChange={(e) => {
                  this.setState({ date: e }, () => {
                    if (e && e.isValid()) {
                      // ...
                      console.log(e);
                      alert('click');
                    }
                  })
                }}
                dateCellRender={this.dateCellRender}
                monthCellRender={monthCellRender}
                fullscreen={false}
                headerRender={({ value, type, onChange, onTypeChange }) => {
                  const start = 0;
                  const end = 12;
                  const monthOptions = [];
                  const current = value.clone();
                  const localeData = value.localeData();
                  const months = [];
                  for (let i = 0; i < 12; i++) {
                    current.month(i);
                    // months.push(localeData.monthsShort(current));
                    months.push(localeData.months(current));
                  }
                  const month = value.month();
                  const year = value.year();
                  let months_name = ''
                  for (let index = start; index < end; index++) {
                    if (index === month) {
                      months_name = months[index]
                    }
                    monthOptions.push(
                      <Select.Option className="month-item" key={`${index}`}>
                        {months[index]}
                      </Select.Option>,
                    );
                  }

                  const options = [];
                  for (let i = year - 10; i < year + 10; i += 1) {
                    options.push(
                      <Select.Option key={i} value={i} className="year-item">
                        {i}
                      </Select.Option>,
                    );
                  }
                  return (
                    <div style={{ padding: 12 }}>
                      <Row gutter={8}>
                        <Col xs={8} sm={6} md={8} lg={8} style={{ textAlign: 'left' }}>
                          <Button type="link" size={'small'} onClick={() => {
                            const current = value.clone();
                            const now = current.add(-1, 'months')
                            onChange(now);
                          }} style={{ minWidth: 0 }}><FiChevronLeft size={24} style={{ marginLeft: 'auto', color: '#444c63' }} /></Button>
                        </Col>
                        <Col xs={8} sm={12} md={8} lg={8} style={{ marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', color: '#444c63', fontSize: 18 }}>
                          <span className="calendar-header-text">{months_name} {String(year)}</span>
                        </Col>
                        <Col xs={8} sm={6} md={8} lg={8} style={{ textAlign: 'right' }}>
                          <Button type="link" size={'small'} onClick={() => {
                            const current = value.clone();
                            const now = current.add(1, 'months')
                            onChange(now);
                          }} style={{ minWidth: 0 }}>
                            <FiChevronRight size={24} style={{ marginRight: 'auto', color: '#444c63' }} />
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  );
                }}
                onPanelChange={this.onPanelChange}
              />
              </div>
      </Layout>
    }
}

export default MySchedule;
